module.exports = __webpack_public_path__ + "static/media/3DPPA8.099ba440.jpg";